module.exports = __webpack_public_path__ + "img/surbey_header.47d9ffa5.svg";